import { Skeleton as MUISkeleton, SkeletonProps } from '@mui/material';

export { type SkeletonProps } from '@mui/material';

export function Skeleton(props: SkeletonProps) {
  return <MUISkeleton {...props} />;
}
